import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { PatchUser, updateUser } from "@/api";
import { useUser } from "@/providers/context";

export const useUpdateUser = () => {
  const { uid } = useUser();
  const queryClient = useQueryClient();
  return useMutation<unknown, AxiosError<{ detail: string }>, PatchUser>(
    async (payload) => {
      if (uid) {
        await updateUser({ UserId: uid, ...payload });
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["user_details", uid]);
      },
    },
  );
};
